import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from '@material-ui/core';
import LoadingIcon from '../../Components/Common/LoadingIcon';
import { depositAmount, getUser, clearSuccess } from '../../store/actions/user.actions';
import { Translate } from '../../localization';
import { toastr } from 'react-redux-toastr';
import { currencyType } from '../../config';
class DepositModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            inputAmount: 0,
            inputEmail: null,
            inputCurrency2: null,
            amountError: null,
            emailError: null,
            currency2Error: null,
            loading: false,
        };
    }

    validate(prevState) {
        if (prevState) {
            if (prevState.inputAmount !== this.state.inputAmount) {
                if (!this.state.inputAmount) {
                    this.setState({ amountError: Translate.required });
                } else {
                    this.setState({ amountError: null });
                }
            }

            if (prevState.inputEmail !== this.state.inputEmail) {
                if (!this.state.inputEmail) {
                    this.setState({ emailError: Translate.required });
                } else {
                    this.setState({ emailError: null });
                }
            }

            if (prevState.inputCurrency2 !== this.state.inputCurrency2) {
                if (!this.state.inputCurrency2) {
                    this.setState({ currency2Error: Translate.required });
                } else {
                    this.setState({ currency2Error: null });
                }
            }
        } else {
            if (this.state.inputAmount < 23) {
                this.setState({ amountError: Translate.greaterThanZero });
            }
            // const pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            // if (!this.state.inputEmail){
            //     this.setState({ emailError: Translate.required });
            // } else if (!pattern.test(this.state.inputEmail)) {
            //     this.setState({ emailError: Translate.notValidEmail });
            // }
            if (!this.state.inputEmail) {
                this.setState({ emailError: Translate.required });
            }
            if (!this.state.inputCurrency2) {
                this.setState({ currency2Error: Translate.required });
            }
        }
    }
    handleDepositAmount = () => {
        const { depositError } = this.props;
        if (depositError) {
            toastr.error('', depositError);
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.depositError !== this.props.depositError) {
            this.handleDepositAmount();
            this.setState({ ...this.state, loading: false });
        }
        if (prevProps.closeModal !== this.props.closeModal) {
            // this.handleDepositAmount();
            // this.setState({ ...this.state, loading: false });
            this.props.hideDepositForm();
        }
        this.validate(prevState);
    }

    componentWillUnmount() {
        this.props.clearSuccess();
    }

    handleSubmit = (e) => {
        const { inputAmount, inputEmail, inputCurrency2, emailError, amountError, currency2Error } = this.state;
        if (!emailError
            && !amountError
            && !currency2Error
            && inputAmount > 0
            && inputEmail && inputEmail.length > 0
            && inputCurrency2 && inputCurrency2.length > 0
        ) {
            if (this.state.inputAmount >= 23) {
                this.setState({ loading: true });
                this.props.depositAmount({
                    amount: inputAmount,
                    buyer_email: inputEmail,
                    currency2: inputCurrency2,
                });
            }
        } else {
            this.validate();
        }
    };
    handleChange = (e) => {
        this.setState({
            ...this.state,
            [e.target.id]: e.target.value,
            loading: false
        });
    }
    render() {
        const currencyList2 = currencyType.map((option) => (
            <option key={option.value} value={option.value} selected={this.state.inputCurrency2 === option.value}>
                {option.name}
            </option>
        ));
        const {
            amountError,
            emailError,
            currency2Error,
            loading
        } = this.state;
        return (
            <div className="changes-pass">
                {this.props.depositSuccess ?
                    <div className='div-1'>
                        <div>
                            {this.props.depositSuccess}
                        </div>
                        <button type="button" onClick={() => this.props.clearSuccess()} className="close" data-dismiss="modal" aria-label="Close">
                            Close
                        </button>
                    </div>
                    :
                    <div className='div-1'>
                        <span className={`mt-1 ${amountError ? 'auth__error-field' : ''}`}>
                            <p className="auth__error sm">{'Welcome bonus will automatically be applied!'}</p>
                            {/* <p className="auth__error sm">{Translate.greaterThanZero}</p> */}
                            <input
                                type="number"
                                className="auth__input"
                                id='inputAmount'
                                placeholder={Translate.enterAmount}
                                onChange={this.handleChange}
                            />
                            {/* {amountError && <p className="auth__error sm">{amountError}</p>}                             */}
                        </span>
                        <span className={`mt-2 ${emailError ? 'auth__error-field' : ''}`}>
                            <input
                                type="email"
                                className="auth__input"
                                id='inputEmail'
                                placeholder={Translate.email}
                                onChange={this.handleChange}
                            />
                            {emailError && <p className="auth__error sm">{emailError}</p>}
                        </span>
                        <span className={'mt-1'}>
                            <select className='auth__input deposit_select' id='inputCurrency2' onChange={this.handleChange}>
                                <option disabled selected className='disabled'>{Translate.currency2}</option>
                                {currencyList2}
                            </select>
                            {
                                currency2Error && <p className="auth__error sm">{currency2Error}</p>
                            }
                            <Button
                                variant="contained"
                                className="auth__btn d-flex justify-content-center align-items-center dep-btn"
                                type="submit"
                                onClick={() => this.handleSubmit()}
                                disabled={loading}
                            >
                                {loading ? <LoadingIcon /> : Translate.continue}
                            </Button>
                        </span>
                    </div>
                }
            </div>
        );
    }
}

DepositModal.propTypes = {
    hideDepositForm: PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        depositError: state.user.depositError,
        depositSuccess: state.user.depositSuccess
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        depositAmount: (inputObj) => dispatch(depositAmount(inputObj)),
        getUser: () => dispatch(getUser()),
        clearSuccess: () => dispatch(clearSuccess()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(DepositModal);
